import styled from '@emotion/styled';
import { themeColorPicker, themeValue } from "../../../utils/themeSelectors";

export const StyledCardTitle = styled.div`
  color: ${themeColorPicker('black01')};
  font-size: ${themeValue('fontSizes')('lg')};
  font-weight: 500;
  display: flex;
  align-items: center;
`;
